import Score, { ScoreProps } from "./Score";

export { ScoreProps };
export default Score;
